export const HALO_HERO_STRAPLINE =
  "Halo SuperVPN — QuantumCloak-powered private connectivity";

export const HALO_CUSTOMER_PROMISE = Object.freeze({
  headline: "More secure. Up to 25% faster.",
  description:
    "Private, high-performance protection powered by LightningFlow’s QuantumCloak security feature.",
});

export const HALO_SOFTWARE_BENCHMARK = Object.freeze({
  claim: "Up to 25% faster",
  title: "Halo SuperVPN speed",
  method: "Software-only connection benchmark",
  baseline: Object.freeze({
    label: "Standard connection",
    throughput_mbps: 183.981,
  }),
  optimised: Object.freeze({
    label: "Halo SuperVPN with LightningFlow",
    throughput_mbps: 230.791,
  }),
  measured_improvement_pct: 25.443,
  successful_runs: 3,
  test_note:
    "Comprehensive testing used the same conditions across three successful runs. Performance varies by device, network and location.",
});
